import React from 'react';
import { WorkflowList } from '../../components/Workflow/WorkflowList';

export const WorkflowPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <WorkflowList />
    </div>
  );
}; 